import { Star } from "lucide-react";
import { Reveal, RevealLines } from "./Reveal";
import { motion } from "framer-motion";

const items = [
  {
    quote:
      "Des résultats bluffants dès la première séance. Sans douleur. Un vrai moment pour soi.",
    name: "Claire",
    soin: "Drainage lymphatique",
  },
  {
    quote:
      "Mon corps a retrouvé une meilleure circulation des liquides. Je me sens plus légère et ma silhouette est bien redessinée après 4 séances.",
    name: "Laurie",
    soin: "Maderothérapie",
  },
  {
    quote:
      "Le seul endroit où je ne regarde jamais ma montre. Le temps s'arrête, littéralement.",
    name: "Joana",
    soin: "Maderothérapie",
  },
];

function Stars() {
  return (
    <div className="flex gap-1" aria-label="5 étoiles">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="h-3.5 w-3.5 fill-gold text-gold" />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section
      id="temoignages"
      className="relative bg-cream py-24 md:py-40"
      data-testid="testimonials-section"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <Reveal>
              <div className="flex items-baseline gap-4">
                <span className="chapter-number text-3xl md:text-4xl">05</span>
                <span className="text-[11px] uppercase tracking-[0.3em] text-olive/60">
                  Elles racontent
                </span>
              </div>
            </Reveal>
          </div>
          <div className="md:col-span-7">
            <RevealLines
              lines={["Ce qu'elles disent", "après la séance."]}
              className="font-serif text-olive text-5xl md:text-6xl lg:text-7xl leading-[1] tracking-tighter"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-olive/15">
          {items.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="bg-cream p-10 md:p-14 flex flex-col gap-8"
              data-testid={`testimonial-${i}`}
            >
              <Stars />
              <blockquote className="font-serif text-olive text-2xl md:text-3xl leading-[1.35] tracking-tight">
                <span className="text-gold">“</span>
                {t.quote}
                <span className="text-gold">”</span>
              </blockquote>
              <figcaption className="mt-auto flex items-end justify-between border-t border-olive/15 pt-6">
                <div>
                  <div className="text-olive font-medium text-[15px]">
                    {t.name}
                  </div>
                </div>
                <div className="text-gold text-[11px] uppercase tracking-[0.28em] italic">
                  {t.soin}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
